<template>
    <div id="manage-equipment-devices-form-dialog-component">
        <v-dialog v-model="dialog_manage_devices" max-width="500px">
            <v-card>
                <v-card-title class="text-uppercase font-weight-bold pt-8">
                    {{ $t('manage_equipment_devices_component.title') }}
                </v-card-title>
                <v-card-subtitle class="pt-2 black--text">
                    {{ $t('manage_equipment_devices_component.subtitle') }}
                </v-card-subtitle>
                <v-card-text>
                    <v-combobox
                        v-model="devices"
                        :label="$t('manage_equipment_devices_component.associated_devices')"
                        append-icon=""
                        color="secondary"
                        filled
                        prepend-inner-icon="mdi-camera"
                    >
                        <template v-slot:selection="{ attrs, item, parent, selected }">
                            <v-chip
                                v-for="(device, index) in item_devices"
                                :key="device.id"
                                :input-value="selected"
                                class="pa-1 mt-3 mb-3"
                                close-icon="mdi-delete"
                                small
                            >
                                <span class="pl-2">
                                    {{ device.device_number }}
                                </span>
                                <v-icon class="ml-2" @click="item_devices.splice(index, 1)"> mdi-close-circle</v-icon>
                            </v-chip>
                        </template>
                    </v-combobox>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-spacer />
                    <v-btn class="font-weight-bold" text @click="dialog_manage_devices = false">{{ $t('global.cancel') }} </v-btn>
                    <v-btn class="font-weight-bold" color="secondary" text @click="dialog_manage_devices = false">
                        {{ $t('global.validate') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: 'ManageEquipmentDevicesFormDialogComponent',
    data() {
        return {
            dialog_manage_devices: false,
            devices: [
                {
                    id: 1,
                    device_number: '203855',
                },
                {
                    id: 2,
                    device_number: '20385E',
                },
            ],
            item_devices: [
                {
                    id: 1,
                    device_number: '203855',
                },
                {
                    id: 2,
                    device_number: '20385E',
                },
            ],
        }
    },
    watch: {
        devices(value) {
            let test = {
                id: 10,
                device_number: value,
            }

            this.item_devices.push(test)

            return test
        },
    },
}
</script>
